<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索简称..."
          @on-change="searchBankAccount"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        >
        </Input>
        <Select
          placeholder="筛选公司"
          v-model="company"
          label-in-value
          clearable
          @on-change="choseCompany"
          style="width: 220px; margin-right: 30px"
        >
          <Option
            v-for="item in companyList"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadBankAccount"
          show-total
          simple
          style="margin-right: 24px"
        />
        <Button type="primary" @click="openCreateBankAccountDrawer()"
          >新增收款账号</Button
        >
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="bankAccountList" :height="tableHeight">
      </Table>
    </div>
    <EditBankAccountDrawer ref="EditBankAccountDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import EditBankAccountDrawer from "./EditBankAccountDrawer";
import _ from "lodash";
import dayjs from "dayjs";

const typeToText = {
  trans: "银行转账",
  bankAccBill: "银承",
  commAccBill: "商承",
  check: "支票",
  cash: "现金钞票",
  yun: "云信通",
  jian: "建信融通",
  bankAccBillPaper: "纸质银承",
};

export default {
  name: "BankAccountPage",
  components: { EditBankAccountDrawer },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      digit: 0,
      columns: [
        {
          title: "简称",
          key: "abbr",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditBankAccountDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.abbr
              ),
            ]);
          },
        },
        {
          title: "公司",
          key: "company",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.company.abbr
                ? params.row.company.abbr
                : params.row.company.name
            ),
        },
        {
          title: "收款账号",
          key: "account",
          align: "left",
          render: (h, params) => h("span", params.row.account),
        },
        {
          title: "行号",
          key: "bankNo",
          align: "left",
          render: (h, params) => h("span", params.row.bankNo),
        },
        {
          title: "银行",
          key: "bank",
          align: "left",
          render: (h, params) => h("span", params.row.bank),
        },
        {
          title: "类型",
          key: "type",
          align: "left",
          render: (h, params) =>
            h("span", params.row.type.map((x) => typeToText[x]).join(",")),
        },
        {
          title: "状态",
          key: "active",
          align: "left",
          render: (h, params) => h("span", params.row.active ? "正常" : "停用"),
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "left",
          render: (h, params) => h("span", params.row.createdBy.name),
        },
        {
          title: "备注",
          key: "remark",
          align: "left",
          render: (h, params) => h("span", params.row.remark),
        },
      ],
      filterQuery: {},
      limit: 20,
      tableHeight: 300,
      company: null,
    };
  },
  computed: mapState({
    bankAccountList: (state) => state.bankAccount.bankAccount,
    totalRows: (state) => state.bankAccount.totalCounts,
    currentUser: (state) => state.auth.currentUser,
    companyList: (state) => state.company.companyList,
  }),
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getBankAccount: "bankAccount/getBankAccountAction",
      getCompanyList: "company/getCompanyListAction",
    }),
    async loadBankAccount(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.abbr = this.searchText;
      } else {
        delete this.filterQuery.abbr;
      }
      try {
        this.tableLoading = true;
        await this.getBankAccount(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchBankAccount: _.debounce(function () {
      this.page = 0;
      this.loadBankAccount();
    }, 1000),
    async choseCompany(company) {
      if (company) {
        this.filterQuery.company = company.value;
      } else {
        delete this.filterQuery.company;
      }
      await this.loadBankAccount(this.filterQuery);
    },
    openCreateBankAccountDrawer() {
      this.$refs.EditBankAccountDrawer.openDrawer();
    },
  },
  async created() {
    this.loadBankAccount();
    await this.getCompanyList({ limit: 99 });
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between

.table-wrapper
  width 100%
  height calc(100% - 48px)

.button-group
  display flex

.container
  overflow-y auto

.card-content
  display flex
  flex-wrap wrap

.card-item
  margin 0 20px 20px 0

.item
  display flex
  justify-content space-between
</style>
